import React from 'react'
import ListItem from './ListItem';
// import AppearOnScroll from './AppearOnScroll';

function ProjectList() {
    let projects = require("../projects.json");
    return (
      <div className="">
        
        <div className="grid md:grid-cols-2 gap-12 w-full pb-24 grid-cols-1">
                    {
                        projects.map((project, idx) => {
                        return (
                         <ListItem key={idx} project={project} />
                        );
                    })}
        </div>
        
      </div>
    );
  }
  export default ProjectList;